module.exports = __webpack_public_path__ + "static/media/menu_roleManagement_hoverActive.3f4c5458.svg";